import React from 'react';
import { connect } from 'react-redux';
import QuestionButton from '../elements/QuestionButton';
import { getTitle } from '../../helpers/popupHelper';
import Global from "../../assets/img/icons/global.svg";

const PopupTitle = ({ title, popupId, lang, tag, global, customClass, onlyQ }) => {
  const Tag = tag || 'h2';

  if(onlyQ) {
    return (
      <QuestionButton popupId={popupId}/>
    )
  }

  return (
    <Tag className={'popup-heading-tag ' + (customClass ? customClass : '')}>
      <QuestionButton popupId={popupId}>
        {global ? <img alt="globalIcon" className='global-icon' src={Global} /> : ''} {((title ? title : getTitle(popupId, lang) || '').replace(/Bonus opdrachten/g, "Bonusopdrachten"))}
      </QuestionButton>
    </Tag>
  );
};

export default connect(state => ({ lang: state.gameState.language }))(PopupTitle);



// WEBPACK FOOTER //
// ./src/components/elements/PopupTitle.js